import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Register from './pages/Register';
import ResetPassword from './pages/ResetPassword';
import Roleplay from './pages/Roleplay';
import AdminDashboard from './pages/AdminDashboard';

export default function App() {
  const { isAuthenticated, isAdmin } = useAuth();

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={
        isAuthenticated
          ? <Navigate to={isAdmin ? '/admin' : '/app'} replace />
          : <Login />
      } />
      <Route path="/register" element={
        isAuthenticated
          ? <Navigate to={isAdmin ? '/admin' : '/app'} replace />
          : <Register />
      } />
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* Protected advisor route */}
      <Route path="/app" element={
        <ProtectedRoute>
          <Roleplay />
        </ProtectedRoute>
      } />

      {/* Protected admin route */}
      <Route path="/admin" element={
        <ProtectedRoute requireAdmin>
          <AdminDashboard />
        </ProtectedRoute>
      } />

      {/* Default redirect */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
